import { motion } from "framer-motion";
import { Toaster } from "sonner";
import { MODULES } from "@/lib/modules";
import ModuleCard from "@/components/sections/expansion/ModuleCard";
import GridBackground from "@/components/primitives/GridBackground";

export default function ExpansionModules() {
    return (
        <section
            id="expansion-modules"
            data-testid="expansion-modules-section"
            className="relative bg-tca-panel overflow-hidden"
        >
            <Toaster theme="dark" />
            <GridBackground />
            {/* Magenta accent corner — Expansion Modules canon accent */}
            <div
                aria-hidden="true"
                className="pointer-events-none absolute top-0 right-0 w-[520px] h-[420px]"
                style={{
                    background: "radial-gradient(ellipse, rgba(255,107,255,0.08), transparent 70%)",
                    filter: "blur(40px)",
                }}
            />

            <div className="relative z-10 max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 py-28 sm:py-40">
                {/* Header */}
                <div className="text-center max-w-3xl mx-auto">
                    <motion.div
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6 }}
                        className="font-mono-tight text-[10px] sm:text-[11px] uppercase tracking-[0.36em] text-tca-cyan/85 mb-5"
                        data-testid="modules-eyebrow"
                    >
                        // Expansion Modules
                    </motion.div>
                    <motion.h2
                        initial={{ opacity: 0, y: 16, filter: "blur(6px)" }}
                        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                        data-testid="modules-headline"
                        className="font-display italic text-[42px] leading-[1.04] sm:text-[60px] sm:leading-[1.0] lg:text-[76px] lg:leading-[0.98] tracking-[-0.02em] neon-cyan font-light"
                    >
                        Enhance your capabilities.
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        className="text-tca-ink-muted text-base sm:text-lg mt-5 leading-relaxed"
                    >
                        Modular ecosystem capabilities. Add what you need.
                    </motion.p>
                </div>

                {/* 3x2 grid */}
                <div
                    data-testid="modules-grid"
                    className="
                        mt-16 sm:mt-20 grid
                        grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
                        gap-5 sm:gap-6
                    "
                >
                    {MODULES.map((m, i) => (
                        <ModuleCard key={m.id} module={m} index={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}
